<template>
  <v-container fluid class="rbu-section-detail" v-if="section">
    <v-row class="flex-grow-0">
      <v-btn
        text
        color="primary"
        exact
        :to="{
          name: 'rbu-volume-detail',
          params: {
            editionId: section.edition.id,
            volumeId: section.volume.id,
          },
        }"
      >
        <h3 class="font-weight-regular">&lt;&lt; {{ section.volume.name }}</h3>
      </v-btn>
    </v-row>

    <v-row v-if="section" class="rbu-section-info-wrapper">
      <h3 class="pt-2">{{ section.name }}</h3>
      <v-btn
        color="primary"
        class="ml-4 mt-2"
        small
        @click="uploadTemplate"
        :disabled="!!section.running_task_id"
      >
        Upload Template
      </v-btn>
      <v-btn color="primary" class="ml-4 mt-2" small @click="createItem">
        <v-icon>mdi-plus</v-icon>
        {{ $t("new") }}
      </v-btn>
      <v-btn color="primary" class="ml-4 mt-2" small @click="extra_over">
        <v-icon>mdi-plus</v-icon>
        Add to / Extra over Items
      </v-btn>
      <!-- <v-btn
        color="primary"
        class="ml-4 mt-2"
        small
        :disabled="!!section.running_task_id"
        @click="forceRefreshConfig"
      >
        Re-Apply START/END Config
        {{ section.running_task_id && section.dp_config_task_progress }}
      </v-btn> -->
      <v-btn color="primary" class="ml-4 mt-2" small @click="forceRefresh">
        <v-icon>mdi mdi-refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-row>

    <v-row style="margin-top: 2rem; margin-bottom: 1rem; margin-left: 0.3rem">
      <div style="width: fit-content">
        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              E-SOR TEMPLATE GENERATION
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-btn
                color="primary"
                small
                v-if="section.running_task_id"
                @click="getProgress"
                :disabled="!!section.running_task_id"
              >
                {{ pdf_progress_text() }}
              </v-btn>
              <v-btn
                color="primary"
                small
                v-if="!section.running_task_id"
                :disabled="!section.excel"
                @click="regenPdf"
              >
                {{ section.required_section_integration ? "*" : "" }}
                Section Integration
              </v-btn>

              <v-btn
                color="primary"
                class="ml-4"
                small
                :disabled="
                  !!!section.sor_section || !!!section.sor_section.latest_pdf
                "
                @click="downloadSorPdf"
              >
                {{ section.new_sor_pdf ? "*" : "" }}
                Download SOR PDF
                {{
                  section.sor_section
                    ? section.section_sor_pdf_version === 0
                      ? ""
                      : `(ver. ${section.section_sor_pdf_version + 1})`
                    : ""
                }}
              </v-btn>

              <v-btn
                color="primary"
                small
                class="ml-4"
                @click="downloadTemplate"
              >
                {{ section.new_e_sor_template ? "*" : "" }}
                {{
                  section.edition.type == "NEW_EDITION"
                    ? "Download E-SOR Template"
                    : "Download E-SoR Corrigendum Template"
                }}
                {{
                  section.excel
                    ? `(ver. ${section.section_template_version + 1})`
                    : ""
                }}
              </v-btn>

              <v-btn
                color="primary"
                class="ml-4"
                small
                @click="getCheckSum"
                :disabled="!!!section.excel"
              >
                GET CHECKSUM
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              RBU PDF GENERATION
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-btn
                color="primary"
                class=""
                small
                @click="generateSectionItemPdf"
                :disabled="section && section.running_task_id != null"
              >
                {{ section.required_rbu_pdf_generation ? "*" : "" }}
                {{ generate_section_pdf_text() }}
              </v-btn>
              <v-btn
                color="primary"
                class="ml-4"
                small
                @click="downloadSectionPdf"
                :disabled="section && section.section_pdf_path == null"
              >
                {{ section.new_rbu_pdf ? "*" : "" }}
                Download RBU PDF
                {{
                  section.section_rbu_pdf_version === 0
                    ? ""
                    : `(Ver. ${section.section_rbu_pdf_version + 1})`
                }}
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              SMART VERIFICATION
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-btn
                color="primary"
                small
                @click="smartVerification"
                :disabled="section && section.running_task_id != null"
              >
                {{ section.required_rbu_smart_verification ? "*" : "" }}
                {{ smart_verification_progress_text() }}
              </v-btn>
              <v-btn
                v-if="section"
                color="primary"
                class="ml-4"
                small
                @click="downloadSmartVerification"
                :disabled="section && !section.smart_verification_excel"
              >
                {{ section.new_smart_verification ? "*" : "" }}
                Download Smart Verification
                {{
                  section.section_smart_verification_version === 0
                    ? ""
                    : `(Ver. ${section.section_smart_verification_version + 1})`
                }}
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-row>
    <v-row v-if="section.running_task_result" style="margin-top: 1.2rem">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: start;
          width: 100%;
          gap: 4px;
          color: var(--v-primary-base);
          background-color: yellow;
          width: 100%;
          margin-bottom: 1rem;
        "
      >
        Error: <span>{{ section.running_task_result }}</span>
      </div>
    </v-row>

    <v-row class="" v-if="edition && edition.updating_selected_rate">
      <div class="mt-4 ml-4 mb-0" style="display: flex; flex-direction: column">
        <span style="font-weight: 500; color: var(--v-primary-base)"
          >Item Update Progress: {{ edition.updated_item }}</span
        ><span style="font-size: small">
          *Please avoid updating item before the progress is done.</span
        >
      </div>
    </v-row>

    <v-row class="flex-grow-1 rounded-b">
      <v-tabs
        v-model="tab"
        align-tabs="center"
        bg-color="transparent"
        style="margin-top: 0; width: fit-content"
        background-color="transparent"
      >
        <v-tab :value="'tab-1'">SoR items mapping</v-tab>
        <v-tab-item style="height: 75vh">
          <RbuItemMappingList
            full-height
            style=""
            :extra-filters="{ section_id: [$route.params.sectionId] }"
            :refresh-trigger="refreshMappingTrigger"
            @update:refresh-trigger="refreshMapping"
          ></RbuItemMappingList>
        </v-tab-item>
        <v-tab :value="'tab-2'">SoR items status summary</v-tab>
        <v-tab-item style="height: 75vh">
          <RbuItemList
            full-height
            style=""
            :extra-filters="{ section_id: [$route.params.sectionId] }"
            :refresh-trigger="refreshItemTrigger"
            @update:refresh-trigger="refreshItem"
          ></RbuItemList>
        </v-tab-item>
      </v-tabs>
    </v-row>

    <v-row></v-row>
  </v-container>
</template>
<script>
import { ACTION_TYPES } from "@/store/types";
import {
  computed,
  onMounted,
  ref,
  onBeforeUnmount,
  watch,
  onUnmounted,
} from "@vue/composition-api";
import RbuItemList from "@/components/rbu/RbuItemList.vue";
import RbuItemMappingList from "@/components/rbu/RbuItemMappingList.vue";
import CreateRbuItemDialog from "@/components/rbu/CreateRbuItemDialog.vue";
import ImportRbuSectionTemplateDialog from "@/components/rbu/ImportRbuSectionTemplateDialog.vue";
import i18n from "@/plugins/i18n";

export default {
  name: "RbuSection",
  components: { RbuItemList, RbuItemMappingList },
  setup(props, { root }) {
    const panel = ref([]);
    const section = ref(null);
    const edition = ref(null);
    const refreshMappingTrigger = ref(false);
    const refreshItemTrigger = ref(false);
    const triggerUpload = ref(false);
    const getSection = async function (force = false) {
      if (
        !section.value ||
        (section.value && section.value.running_task_id) ||
        force
      ) {
        // console.log(section.value.section_pdf_task_id);
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/section/",
          params: { section_id: root.$route.params.sectionId },
          opt: { not_blocking: true },
        });

        if (response.body.success) {
          section.value = response.body.section;
        }
      }
    };

    const tab = computed({
      get() {
        return root.$store.state.rbuSectionItemList.tab;
      },
      set(tab) {
        updateTab(tab);
      },
    });

    const updateTab = async function (tab) {
      await root.$store.dispatch(ACTION_TYPES.RBU_UPDATE_ITEM_LIST_TAB, tab);
    };

    const refreshMapping = async (target = true) => {
      refreshMappingTrigger.value = target;
    };

    const refreshItem = async (target = true) => {
      refreshItemTrigger.value = target;
    };

    const createItem = async function () {
      const itemId = await root.$dialog.showAndWait(CreateRbuItemDialog, {
        showClose: false,
        persistent: true,
        title: "Create New RBU Item",
        sectionId: root.$route.params.sectionId,
      });

      if (itemId) {
        root.$router.push({ name: "rbu-item", params: { itemId } });
      }
    };

    const extra_over = async function () {
      root.$router.push({
        name: "rbu-item-extra",
        params: { rbu_item_extra_section_id: root.$route.params.sectionId },
      });
    };

    const downloadTemplate = async function () {
      try {
        let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/section/download_template/",
          params: {
            section_id: root.$route.params.sectionId,
          },
          opt: { extra: { responseType: "arraybuffer" } },
        });

        let blob = new Blob([response.data], {
          type: response.headers.get("content-type"),
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        // link.download = decodeURI(response.headers.get("content-filename"));
        const _filename = `${section.value.edition.edition}_S${
          section.value.order_no
        }_Ver${section.value.section_template_version + 1}.xlsx`;
        link.download = _filename;
        link.click();

        getSection(true);
      } catch (e) {
        console.log(e);
      }
    };

    const uploadTemplate = async function () {
      const needRefresh = await root.$dialog.showAndWait(
        ImportRbuSectionTemplateDialog,
        {
          showClose: false,
          persistent: true,
          sectionId: root.$route.params.sectionId,
        }
      );

      if (needRefresh) {
        getSection(true);
        triggerUpload.value = true;
      }
    };

    const regenPdf = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/regen_pdf/",
        params: { section_id: root.$route.params.sectionId },
      });

      if (response.body.success) {
        getSection(true);
      }
    };

    const getProgress = async function () {
      await getSection(true);

      if (section.value.running_task_result) {
        alert(section.value.running_task_result);
      } else if (section.value.running_task_progress) {
        alert(section.value.running_task_progress);
        // root.$store.dispatch(ACTION_TYPES.SHOW_SNACKBAR, section.value.running_task_progress);
      }
    };

    const pdf_progress_text = () => {
      let _text = "Section Integration";

      if (section.value && section.value.running_task_progress) {
        return section.value.running_task_progress;
      } else {
        return _text;
      }
    };

    const smart_verification_progress_text = () => {
      let _text = "Smart Verification";

      if (section.value && section.value.smart_verification_task_progress) {
        return section.value.smart_verification_task_progress;
      } else {
        return _text;
      }
    };

    const getEdition = async function (force = false) {
      if (!edition.value || edition.value.updating_selected_rate || force) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/edition/",
          params: { edition_id: root.$route.params.editionId },
          opt: { not_blocking: true },
        });
        if (response.data && response.data.success) {
          edition.value = response.data.edition;
        }
      }
    };

    const generateSectionItemPdf = async function () {
      let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/generate_section_pdf/",
        params: {
          section_id: section.value.id,
        },
        // opt: { extra: { responseType: "arraybuffer" } },
      });

      if (response && response.data && response.data.success) {
        getSection(true);
      }
    };

    const downloadSectionPdf = async function () {
      let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/download_section_pdf/",
        params: {
          section_id: section.value.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(response.headers.get("content-filename"));
      link.click();

      getSection(true);
    };

    const smartVerification = async function () {
      let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/smart_verification/",
        params: {
          section_id: section.value.id,
        },
      });

      if (response && response.data && response.data.success) {
        getSection(true);
      }
    };

    const downloadSmartVerification = async function () {
      let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/download_smart_verification_excel/",
        params: {
          section_id: section.value.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(response.headers.get("content-filename"));
      link.click();

      getSection(true);
    };

    const downloadSorPdf = async function () {
      let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/download_sor_pdf/",
        params: {
          section_id: section.value.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(response.headers.get("content-filename"));
      link.click();

      getSection(true);
    };

    const generate_section_pdf_text = () => {
      if (section.value && section.value.running_task_id) {
        let text = "Generate Section PDF";
        try {
          let meta = JSON.parse(section.value.section_pdf_task_progress);
          let total = meta.total;
          let current = meta.current;
          let msg = meta.msg;
          text = `${current}/${total} (${msg})`;
        } catch (e) {
          // let text = "Generate Section PDF (Something get wrong)";
        }
        // return section.section_pdf_task_progress;
        return text;
      } else {
        return "Generate Section PDF";
      }
    };

    const getCheckSum = async function () {
      let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/get_download_template_check_sum/",
        params: {
          section_id: section.value.id,
        },
      });

      if (response && response.data && response.data.success) {
        try {
          await navigator.clipboard.writeText(response.data.checksum);
          root.$store.dispatch(ACTION_TYPES.SHOW_SNACKBAR, {
            message: `Checksum is copied: ${response.data.checksum}`,
            color: "green",
            icon: "mdi mdi-clipboard-check-outline",
          });
          // alert(`Checksum is copied: ${response.data.checksum}`);
        } catch (err) {
          console.error("Failed to copy checksum to clipboard: ", err);
        }
      }
    };

    const refreshByTab = () => {
      if (tab.value === 0) {
        refreshMapping();
      } else {
        refreshItem();
      }
    };

    const forceRefreshConfig = async () => {
      await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/fix_dp_config/",
        params: {
          section_id: section.value.id,
        },
      });

      getSection(true);
    };

    const refreshEditionAndSection = () => {
      getEdition();
      getSection();
    };

    const forceRefresh = () => {
      getEdition(true);
      getSection(true);
      refreshByTab();
    };

    let refreshInterval = null;
    onMounted(() => {
      getSection(true);
      getEdition(true);

      refreshInterval = setInterval(refreshEditionAndSection, 1000);
    });

    onUnmounted(() => {
      if (refreshInterval) {
        clearInterval(refreshInterval);
      }
    });

    // watch(refreshMappingTrigger, (newValue) => {
    //   console.log("refresh", newValue);
    // });

    // watch(refreshItemTrigger, (newValue) => {
    //   console.log("refresh1", newValue);
    // });

    watch(section, (newValue) => {
      if (newValue.running_task_id == null && triggerUpload.value) {
        refreshByTab();
        triggerUpload.value = false;
      }
    });

    return {
      section,
      tab,
      createItem,
      refreshMappingTrigger,
      downloadTemplate,
      uploadTemplate,
      regenPdf,
      getSection,
      getProgress,
      extra_over,
      edition,
      forceRefresh,
      refreshItemTrigger,
      refreshMapping,
      refreshItem,
      generateSectionItemPdf,
      downloadSectionPdf,
      generate_section_pdf_text,
      smartVerification,
      downloadSmartVerification,
      pdf_progress_text,
      smart_verification_progress_text,
      getCheckSum,
      panel,
      downloadSorPdf,
      forceRefreshConfig,
    };
  },
};
</script>

<style lang="less">
.rbu-section-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rbu-section-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .rbu-section-info {
      flex: 1 1 0;
    }
  }
}

.theme--dark.v-tabs-items {
  background-color: transparent !important;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}
</style>
